export interface DataRow {
    uid: string;
    displayName: string;
    email: string;
    photoURL: string;
    phoneNumber: string;
    disabled: boolean;
    type: string;
    emailVerified: boolean;
    gruposIds: string[];
    atendentes?: string[];
    selfSchedulingBlocked?: boolean;
    selfSchedulingBlockMode?: 'ALL' | 'WEEK_DAYS';
    selfSchedulingBlockedWeekDays?: number[];
}

const WEEK_DAY_LABELS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

export const onlyDigits = (value?: string | null) => (value || '').replace(/\D/g, '');

export const formatPhone = (phone?: string | null) => {
    const digits = onlyDigits(phone);

    if (digits.startsWith('55') && digits.length === 13) {
        return `+55 (${digits.slice(2, 4)}) ${digits[4]} ${digits.slice(5, 9)}-${digits.slice(9)}`;
    }

    if (digits.startsWith('55') && digits.length === 12) {
        return `+55 (${digits.slice(2, 4)}) ${digits.slice(4, 8)}-${digits.slice(8)}`;
    }

    return phone || '';
};

export const getSelfSchedulingLabel = (client: DataRow) => {
    if (!client.selfSchedulingBlocked) return 'Liberado';
    if (client.selfSchedulingBlockMode !== 'WEEK_DAYS') return 'Bloqueado em todos os dias';

    const days = (client.selfSchedulingBlockedWeekDays || []).map((day) => WEEK_DAY_LABELS[day]).filter(Boolean);
    return days.length ? `Bloqueado em ${days.join(', ')}` : 'Bloqueado em dias selecionados';
};
